import { HttpError } from 'react-admin';
import errorMessages, { ErrorCodes } from '../constants/errorMessages';

const statusMessages: Record<number, string> = {
  429: 'Too many attempts. Please wait a moment before trying again',
};

const errorNotification = (error: unknown, defaultMessage = 'Unexpected error') => {
  if (error instanceof HttpError) {
    return errorMessages[error.message as ErrorCodes]
      ?? statusMessages[error.status]
      ?? (error.message || defaultMessage);
  }

  if (typeof error === 'string') {
    return errorMessages[error as ErrorCodes] ?? defaultMessage;
  }

  return defaultMessage;
};

export default errorNotification;
